// La barra de botones de Android: escondida, como en los juegos.
//
// Patricio, tres veces. La última (24-08) con la captura marcada en rojo:
// «en el apk creo que deberías investigar para ocultar, hay muchísimas
// aplicaciones que ocultan eso, como los juegos y otro tipo de aplicaciones».
//
// 🔴 QUÉ SE PUEDE Y QUÉ NO, comprobado leyendo el propio módulo
// (`expo-navigation-bar` 5.x, `build/NavigationBar.js`) en vez de suponerlo:
//
//   setVisibilityAsync    ✅ funciona SIEMPRE  ← esconderla, lo que se pedía
//   setButtonStyleAsync   ✅ funciona SIEMPRE
//   setStyle              ✅ funciona SIEMPRE
//   setBackgroundColorAsync  ⚠ SOLO si el modo «borde a borde» está apagado
//   setBehaviorAsync         ⚠ SOLO si el modo «borde a borde» está apagado
//
// Por eso el intento anterior no cambió nada: pedía FONDO, que es justo lo que
// Android ya no deja pintar desde que dibuja de borde a borde. Ahora se pide lo
// que sí se puede — que desaparezca.
//
// Se sigue reapareciendo al deslizar desde abajo (Android no permite quitarla
// del todo, y hace bien: es como se sale de la app), y vuelve a esconderse
// sola. Por eso hay que volver a pedirlo cada vez que la app vuelve al frente:
// al volver de segundo plano Android la restaura.
import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { C } from '@/constants/theme';

export default function BarraSistema() {
  useEffect(() => {
    if (Platform.OS !== 'android') return;
    let vivo = true;

    const aplicar = async () => {
      try {
        const NavigationBar = await import('expo-navigation-bar');
        if (!vivo) return;
        // Lo importante: que no se vea.
        try { await NavigationBar.setVisibilityAsync('hidden'); } catch { /* no en esta versión */ }
        // Y para el momento en que reaparece al deslizar, que al menos vaya a juego.
        try { await NavigationBar.setButtonStyleAsync('light'); } catch { /* idem */ }
        try { NavigationBar.setStyle('dark'); } catch { /* idem */ }
        // Donde Android todavía lo permite (14 y anteriores), también el fondo.
        try { await NavigationBar.setBackgroundColorAsync(C.bg); } catch { /* borde a borde */ }
      } catch { /* sin el módulo: la barra se queda como esté */ }
    };

    aplicar();
    /* 🔴 Y OTRA VEZ AL VOLVER AL FRENTE. Sin esto se esconde al arrancar y
       reaparece para siempre en cuanto sales y vuelves — que es exactamente
       como se vería «arreglado a medias». */
    const sub = AppState.addEventListener('change', (e) => { if (e === 'active') aplicar(); });
    return () => { vivo = false; sub.remove(); };
  }, []);
  return null;
}
